export default {
  jsonLabel: 'JSON',
  pathLabel: 'Ruta',
  fieldLabel: 'Campo',
  insert: 'Insertar'
}
